import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import moment from 'moment';

const defaultDateFormat = 'MM/DD/yyyy';

type Props = {
  type: 'date' | 'time' | 'text' | 'number';
  inputRef: React.RefObject<HTMLInputElement>;
  inputValue: string;
  setInputValue: (value: string) => void;
  format?: string;
  minValue?: string;
  maxValue?: string;
  required: boolean;
};

const InputPicker = ({
  type,
  inputRef,
  inputValue,
  setInputValue,
  format = defaultDateFormat,
  minValue = '',
  maxValue = '',
  required,
}: Props) => {
  const [displayDate, setDisplayDate] = useState('');

  useEffect(() => {
    if (type === 'date') {
      setDisplayDate(inputValue ? moment(inputValue).format(format) : '');
    }
  }, [inputValue, format, type]);

  return (
    <div className="flex flex-col space-y-2">
      {type === 'date' ? (
        <>

          <button
            type="button"
            className={`w-full px-4 py-[19px] border md:rounded-tr-none md:rounded-br-none md:rounded-tl-lg md:rounded-bl-lg rounded-lg flex items-center justify-between text-sm bg-white`}

          >
            <span>{displayDate}</span>
            <FontAwesomeIcon icon={faCalendar} />
          </button>

          {/* Hidden date input for native date picker */}
          <input
            ref={inputRef}
            type="date"
            min={minValue}
            max={maxValue}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            className="w-full px-4 py-4 bg-white absolute inset-0 -z-[1] opacity-0 pointer-events-none"
            required={required}
          />
        </>
      ) : (
        <input
          type={type}
          min={minValue}
          max={maxValue}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className={`w-full px-4 py-4 border md:rounded-tl-none md:rounded-bl-none md:rounded-tr-lg md:rounded-br-lg  rounded-lg`}
          required={required}
        />
      )}
    </div>
  );
};

export default InputPicker;
